var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsEnum, IsInt, IsOptional, IsString, MaxLength, Max, Min } from 'class-validator';
import { CatalogHeilmittelRole } from '../../prescription-validation/enums/catalog-heilmittel-role.enum.js';
/**
 * The Heilmittelkatalog option the physician actually ticked, recorded verbatim
 * on the Verordnung — one row per prescribed Heilmittel (#1425 slice 1).
 *
 * Identified by its **natural key**: the Diagnosegruppe code plus the option
 * name, resolved against the Katalog-Release valid at the Ausstellungsdatum.
 * Never a foreign key to a release-scoped catalog row — ADR-0026's
 * insert-only-releases rule, the same treatment `diagnosisGroupCode` already
 * gets one column away on the same record.
 *
 * Why this exists at all: the Katalog carries one option per prescribable
 * Heilmittel per Diagnosegruppe, and siblings such as `KG` (X0501, 29,63 €) and
 * `KG Gruppe` (X0601, 13,26 €) resolve to the same practice TreatmentConcept.
 * Storing only the concept discards the physician's choice, which both hides
 * `KG Gruppe` from the picker and lets a `KG` Verordnung be billed on the
 * Gruppenbehandlung Positionsnummer.
 */
export class PrescribedCatalogOptionInputDto {
    /** SDHM Diagnosegruppe code (e.g. `EX`). Half of the natural key. */
    diagnosisGroupCode;
    /** Catalog option name (e.g. `KG`, `KG Gruppe`). The other half of the key. */
    optionName;
    /** vorrangig / ergänzend / standardisierte Kombination. */
    role;
    /**
     * Behandlungseinheiten one session of this Heilmittel delivers. An integer,
     * not a `doppelbehandlung` boolean: Podologie carries a position billable
     * twice per Leistungstag, so the fact is a count. Defaults to 1.
     */
    unitsPerSession;
}
__decorate([
    Expose(),
    IsString(),
    MaxLength(10),
    __metadata("design:type", String)
], PrescribedCatalogOptionInputDto.prototype, "diagnosisGroupCode", void 0);
__decorate([
    Expose(),
    IsString(),
    MaxLength(255),
    __metadata("design:type", String)
], PrescribedCatalogOptionInputDto.prototype, "optionName", void 0);
__decorate([
    Expose(),
    IsEnum(CatalogHeilmittelRole),
    __metadata("design:type", String)
], PrescribedCatalogOptionInputDto.prototype, "role", void 0);
__decorate([
    Expose(),
    IsInt(),
    Min(1),
    Max(9),
    IsOptional(),
    __metadata("design:type", Number)
], PrescribedCatalogOptionInputDto.prototype, "unitsPerSession", void 0);
export class PrescribedCatalogOptionResponseDto {
    id;
    createdAt;
    updatedAt;
    diagnosisGroupCode;
    optionName;
    role;
    unitsPerSession;
}
//# sourceMappingURL=prescribed-catalog-option.dto.js.map